import { useCallback, useEffect, useState } from 'react'
import useMfeLoader from 'src/hooks/useMfeLoader'

/**
 * @param {"mfe-example"|"mfe-hr-portal"|"mfe-erp-portal"|"mfe-itp"|"mfe-playbook"|"mfe-task-center"|"mfe-ccp2"|"mfe-csod"} mfeKey
 * @param {boolean} [eager=false] start loading the MFE as soon as the hook was called. Use only when you're sure we're mounting.
 * @return {unknown}
 */
export default function useMfe(mfeKey, eager = false) {
    const [mfe, setMfe] = useState(null)
    const { loadMfe } = useMfeLoader()

    const startMfeLoad = useCallback(() => {
        if (!mfe) {
            loadMfe(mfeKey)
                .then(mod => {
                    setMfe(mod)
                })
                .catch(err => {
                    console.error(err)
                })
        }
    }, [loadMfe, mfeKey, mfe])

    useEffect(() => {
        if (!mfe && eager) {
            startMfeLoad()
        }
    }, [mfeKey, loadMfe, mfe, eager, startMfeLoad])

    return { mfe, loadMfe: startMfeLoad }
}
